export const API_PATH_ApiDeviceMgmtRegionGet = '/services/devices-mgtm/apiDeviceMgmtRegionGet';
